import styled from "styled-components"

export const Grid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-row-gap: 40px;
	grid-column-gap: 40px;
	margin: 40px 0;
`
